export const NBA_WIDGET_URL =
  process.env.APP_ENV === 'production'
    ? 'https://cdn.nba.com/manage/sites/101/uwmaster/UW37-2023-2023-IN-SEASON-TOURNAMENT-FLOWCODE/UW37-2023-2023-IN-SEASON-TOURNAMENT-FLOWCODE.js'
    : 'https://cdn-qa.nba.com/manage/sites/101/uwmaster/UW37-2023-2023-IN-SEASON-TOURNAMENT-FLOWCODE/UW37-2023-2023-IN-SEASON-TOURNAMENT-FLOWCODE.js'
